import { useEffect, useRef, FC, ReactElement } from 'react';
import { useParams, useNavigate } from 'react-router';

import { APP_ROUTES } from '@navigation/types';

type ShowRedirectProps = {
  useCurrentShowIdSelector: () => string | null;
  ShowComponent: FC;
};

const ShowRedirect = ({
  useCurrentShowIdSelector,
  ShowComponent,
}: ShowRedirectProps): ReactElement | null => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const currentShowId = useCurrentShowIdSelector();
  const hasRedirected = useRef<boolean>(false);

  useEffect(() => {
    if (hasRedirected.current) {
      return;
    }

    if (id && currentShowId !== id) {
      hasRedirected.current = true;
      navigate(APP_ROUTES.SHOWS_INITIALIZATION, {
        state: { id },
        replace: true,
      });
    } else if (!id) {
      hasRedirected.current = true;
      navigate(APP_ROUTES.HOME, { replace: true });
    }
    // eslint-disable-next-line
  }, [id, navigate]);

  if (currentShowId === id) {
    return <ShowComponent />;
  }

  return null;
};

export default ShowRedirect;
